const FlightNextDay = (state) => state.FlightNextDay
const Rebook = (state) => state.Rebook

export default {
  FlightNextDay,
  Rebook
}
